import React from "react";

const HERO_URL =
  "/images/illustrations/fichefrais.jpg";

export default function HeroHeader() {
  return (
    <div className="relative h-[260px] md:h-[360px] w-full overflow-hidden">
      <img
        src={HERO_URL}
        alt="Fiche de frais — Ligue Nouvelle-Aquitaine Judo"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/25 to-transparent" />
      <div className="relative z-10 max-w-[1200px] mx-auto h-full flex items-end px-4 pb-6">
        <div className="text-white drop-shadow">
          <h1 className="text-2xl md:text-4xl font-bold">Fiche de frais</h1>
          <p className="text-sm md:text-base opacity-90 mt-1">
            Coordonnées • Déplacements • Frais • Justificatifs
          </p>
        </div>
      </div>
    </div>
  );
}
